// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2luIG","title":"Images45_title__3kyYn","images":"Images45_images__8rWIf"};